export enum VehiclePriceType {
  ADVERTISED = 'advertised',
  DISCOUNTED = 'discounted',
}

export enum VehiclePriceChangeType {
  INITIAL_PRICE = 'initial_price',
  DISCOUNT_APPLIED = 'discount_applied',
  DISCOUNT_REMOVED = 'discount_removed',
  PRICE_INCREASE = 'price_increase',
  PRICE_DECREASE = 'price_decrease',
  MARKET_ADJUSTMENT = 'market_adjustment',
  PROMOTIONAL_PRICE = 'promotional_price',
  SEASONAL_ADJUSTMENT = 'seasonal_adjustment',
}

export interface VehiclePriceHistory {
  id: number;
  vehicleUuid: string;
  priceType: VehiclePriceType;
  oldPrice: number | null;
  newPrice: number;
  changeType: VehiclePriceChangeType;
  description: string | null;
  descriptionLabel: string | null;
  createdAt: string;
  createdBy?: {
    uuid: string;
    name: string;
    email: string;
  };
}

export interface StorePriceHistoryRequest {
  price_type: VehiclePriceType;
  old_price?: number | null;
  new_price: number;
  change_type: VehiclePriceChangeType;
  description?: string | null;
}

/** GET/PUT /api/vehicles/{uuid}/anchor-price-declaration, and `anchor` on advertising-list rows (BRIEFD-7440). */
export interface AnchorPriceDeclarationState {
  enabled: boolean;
  /** Bought/received before 10.09.2026, entered after it, and the dealer hasn't answered yet. */
  needsConfirmation?: boolean;
  declaration?: {advertisedFrom: string; price: number} | null;
  anchorPrice?: number | null;
  anchorPriceDate?: string | null;
  anchorPriceSource?: string | null;
  /** Kept off the public cjenik, e.g. a demo car that isn't for sale (BRIEFD-7538). */
  hiddenFromPriceList?: boolean;
}
